export class ProductProcessorsCollection {
    constructor() {
        this.processors = new Map();
    }
    invokeProcessors(productItem, attrComputer) {
        this.processors.forEach((processor, id) => {
            console.groupCollapsed('Invoking processor', `"${id}"`);
            processor(productItem, attrComputer);
            console.groupEnd();
        });
    }
    registerProcessor(id, processor) {
        if (this.processors.has(id.valueOf())) {
            throw Error(`Processor with id ${id} already exists.`);
        }
        if ('invoke' in processor) {
            this.processors.set(id.valueOf(), (productItem, attrComputer) => processor.invoke(productItem, attrComputer));
        }
        else {
            this.processors.set(id.valueOf(), processor);
        }
    }
    unregisterProcessor(id) {
        if (this.processors.has(id.valueOf())) {
            return this.processors.delete(id.valueOf());
        }
        return false;
    }
}
